import { useRef } from "react";
import useComponentSize, { ComponentSize } from "@rehooks/component-size";

export type DimensionObject = ComponentSize;

type UseDimensionsHook = [React.MutableRefObject<any>, ComponentSize];

/* modified from https://github.com/Swizec/useDimensions to use parent node instead */
const useContainerDimensions = (): UseDimensionsHook => {
  const ref = useRef();
  const size = useComponentSize(ref);

  return [ref, size] as [React.MutableRefObject<any>, ComponentSize];
};

export default useContainerDimensions;
